<template>
  <v-dialog :model-value="dialog_view" max-width="1200" @click:outside="close" @keydown.esc="close">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-card-text style="padding: 15px 15px 15px 15px !important">
              <p class="fs-16" style="font-weight: 600">Arrastre las ordenes de envios para acomodar su orden</p>
              <table class="table table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>Número</th>
                    <th>Canal de Venta</th>
                    <th>Cliente</th>
                    <th>Dirección</th>
                    <th>Referencia externa</th>
                    <th>Resultado</th>
                  </tr>
                </thead>

                <draggable v-model="list" tag="tbody" class="cursor" item-key="id" @end="onDragEnd">
                  <template #item="{ element }">
                    <tr :key="element.id">
                      <td>{{ element.code }}</td>
                      <td>{{ element.canal_venta_name != null ? element.canal_venta_name : "-" }}</td>
                      <td>{{ element.client_name != null ? element.client_name : "-" }}</td>
                      <td>{{ element.address }}</td>
                      <td>{{ element.external_reference != null ? element.external_reference : "-" }}</td>

                      <td>
                        <span
                          v-if="element.response_msg"
                          :class="{
                            'response-ok': element.response_msg === 'Reserva exitosa',
                            'response-error': element.response_msg !== 'Reserva exitosa',
                          }"
                        >
                          {{ element.response_msg }}
                        </span>

                        <!-- Add your reservation button/checkbox here -->
                      </td>
                    </tr>
                  </template>
                </draggable>
              </table>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" variant="text" @click="close">Cancelar</v-btn>
        <v-btn color="green" text @click="confirmReserve()" :loading="loading" :disabled="disabled_button"> Reservar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import UserTypeConstant from "@/constants/user_type";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  props: {
    title: String,
    dialog_view: Boolean,
    selected: Array,
    user_type: String,
    loading: Boolean,
    confirm: Function,
    updateSelected: Function, // Function to update selected items
    dock: Object,
  },
  data: () => ({
    list: [],
    formatUtils,
    userTypeConstant: UserTypeConstant,
    disabled_button: false,
  }),
  watch: {
    dialog_view(val) {
      if (val) {
        this.list = this.selected.map((item) => ({ ...item, response_msg: null }));
      }
    },
    dock(val) {
      if (val != null && val.id) {
        this.confirmReserve();
      }
    },
  },
  methods: {
    close() {
      this.list = [];
      this.$emit("closeDialog");
    },
    async confirmReserve() {
      if (!this.dock || !this.dock.id) {
        this.$emit("dockMissing");
        return;
      }

      let success = true;
      for (const item of this.list) {
        try {
          const response = await this.confirm(item.id, this.dock);

          if (response && response.status === true) {
            item.response_msg = "Reserva exitosa";
          } else {
            item.response_msg = `${response?.msg || "Error desconocido"}`;
            success = false;
          }
        } catch (error) {
          item.response_msg = error?.message || "Error desconocido";
          success = false;
        }
      }

      if (success) {
        this.close();
      }

      this.$emit("loading", false);
      this.disabled_button = true;
    },

    onDragEnd() {
      // Optional: handle drag end event if needed
    },
  },
};
</script>

<style scoped>
.cursor {
  cursor: move;
}
.response-ok {
  color: green;
  font-weight: bold;
}
.response-error {
  color: red;
  font-weight: bold;
}
</style>
